.registerWrapper {
  width: 100%;
  display: flex;
  justify-content: center;
}

.register {
  width: 90%;
  display: flex;
  flex-direction: column;
}

.header {
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
  margin-bottom: 1.5rem;
}

.headerWrapper {
  display: flex;
  gap: 0.5rem;
}

.registrationDetails {
  display: flex;
  flex-direction: column;
}

.accountTypesWrapper {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.accountTypes {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.accountType {
  display: flex;
  flex-direction: column;
  margin-right: 0.5rem;
}

.accountTypeWrapper {
  display: flex;
  align-items: center;
  gap: 0.8rem;
}

.attributesWrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 0.5rem;
}

.detailsWrapper {
  margin-top: 2rem;
}

.uploadDetailsWrapper {
  margin-top: 1rem;
}

.panContainer {
  display: flex;
  flex-direction: row;
  gap: 1rem;
}

.panInput {
  width: 20%;
}

.divider {
  height: 1px;
  border-top: 1px solid #dad9d9;
  margin-top: 3.5rem;
  margin-bottom: 1rem;
  margin-left: 15%;
  margin-right: 15%;
}

.halfdivider {
  composes: divider;
  margin-top: 2rem;
  margin-bottom: 0;
  margin-left: 40%;
  margin-right: 40%;
}

.tAndC {
  display: flex;
  gap: 1rem;
  margin-top: 0.5rem;
}

.submitBtn {
  margin-top: 0.5rem;
  margin-right: 90%;
}

.errorMessage {
  margin-top: 1rem;
  margin-bottom: 5rem;
}

.errorMessageText {
  padding: 0 0.3rem;
}

.specialText {
  color: var(--green-secondary-color);
}

@media (max-width: 767.98px) {
  .submitBtn {
    margin-right: 50%;
  }
}
